document.addEventListener('DOMContentLoaded', function () {
  /* ---------------- Cart Drawer ---------------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var openBtns = document.querySelectorAll('[data-cart-drawer-open]');
  var closeBtns = document.querySelectorAll('[data-cart-drawer-close]');

  function openDrawer(e) {
    if (e) e.preventDefault();
    if (drawer) drawer.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (drawer) drawer.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }
  openBtns.forEach(function (btn) { btn.addEventListener('click', openDrawer); });
  closeBtns.forEach(function (btn) { btn.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* Intercept product-add forms to open the drawer via AJAX Cart API */
  var addForms = document.querySelectorAll('form[data-product-form]');
  addForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) { return res.json().then(function (err) { throw err; }); }
          return res.json();
        })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          renderCartDrawer(cart);
          openDrawer();
        })
        .catch(function () {
          form.submit(); // fallback to normal form submit if AJAX fails
        })
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
        });
    });
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCartDrawer(cart) {
    var body = document.getElementById('CartDrawerBody');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      return;
    }

    var itemsHtml = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_160x160$1$2') + '" alt="" width="80" height="80" loading="lazy">' : '';
      return (
        '<li class="cart-drawer__item">' + img +
        '<div class="cart-drawer__item-info">' +
        '<p class="cart-drawer__item-title">' + item.product_title + '</p>' +
        '<p class="cart-drawer__item-price">' + moneyFormat(item.final_line_price) + '</p>' +
        '</div></li>'
      );
    }).join('');

    body.innerHTML =
      '<ul class="cart-drawer__items" role="list">' + itemsHtml + '</ul>' +
      '<div class="cart-drawer__footer">' +
      '<div class="cart-drawer__subtotal"><span>Subtotal</span><span>' + moneyFormat(cart.total_price) + '</span></div>' +
      '<a href="/cart" class="btn btn--secondary btn--full">View Cart</a>' +
      '<a href="/checkout" class="btn btn--primary btn--full">Checkout Securely &rarr;</a>' +
      '</div>';
  }

  /* ---------------- Mobile nav ---------------- */
  var burger = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var isOpen = mobileNav.getAttribute('data-open') === 'true';
      mobileNav.setAttribute('data-open', isOpen ? 'false' : 'true');
    });
  }

  /* ---------------- FAQ accordion ---------------- */
  document.querySelectorAll('.faq-item__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var answer = item.querySelector('.faq-item__answer');
      var isOpen = item.getAttribute('data-open') === 'true';

      // close siblings
      item.parentElement.querySelectorAll('.faq-item').forEach(function (sib) {
        sib.setAttribute('data-open', 'false');
        sib.querySelector('.faq-item__answer').style.maxHeight = null;
      });

      if (!isOpen) {
        item.setAttribute('data-open', 'true');
        answer.style.maxHeight = answer.scrollHeight + 20 + 'px';
      }
    });
  });

  /* ---------------- Sticky buy bar ---------------- */
  var stickyBar = document.querySelector('[data-sticky-buy-bar]');
  var heroBuyBtn = document.querySelector('[data-primary-buy-trigger]');
  if (stickyBar && heroBuyBtn) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.setAttribute('data-visible', entry.isIntersecting ? 'false' : 'true');
      });
    }, { threshold: 0 });
    observer.observe(heroBuyBtn);
  } else if (stickyBar) {
    window.addEventListener('scroll', function () {
      stickyBar.setAttribute('data-visible', window.scrollY > 700 ? 'true' : 'false');
    });
  }

  /* ---------------- Product gallery thumbs ---------------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-gallery-main]');
      var group = thumb.closest('[data-gallery]');
      if (main) main.src = thumb.dataset.fullSrc || thumb.src;
      group.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.removeAttribute('data-active'); });
      thumb.setAttribute('data-active', 'true');
    });
  });

  /* ---------------- Countdown timer (optional urgency) ---------------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var minutes = parseInt(el.dataset.countdownMinutes || '15', 10);
    var storageKey = 'myo_countdown_deadline';
    var deadline = sessionStorage.getItem(storageKey);
    if (!deadline) {
      deadline = Date.now() + minutes * 60000;
      sessionStorage.setItem(storageKey, deadline);
    }
    deadline = parseInt(deadline, 10);

    function tick() {
      var diff = Math.max(0, deadline - Date.now());
      var m = Math.floor(diff / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (diff > 0) requestAnimationFrame(function () { setTimeout(tick, 250); });
    }
    tick();
  });
});
